import React from "react";
import * as yaml from "js-yaml";
import DualEditorConvert from "../components/DualEditorConvert";
import AdSenseAd from "../components/AdSenseAd";

const convertYamlToJson = (input) => {
  const parsed = yaml.load(input);
  return JSON.stringify(parsed, null, 2);
};

const YamlToJson = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
  <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-blue-600 to-indigo-600 text-transparent bg-clip-text mb-2">YAML to JSON Converter</h1>
  <section className="text-gray-700 dark:text-gray-300 text-center max-w-2xl mx-auto mb-6">
    <p className="mb-3">
      Instantly convert your YAML data into JSON format for use in web apps, APIs, and configuration files. This tool runs 100% in your browser—your data stays private.
    </p>
    <DualEditorConvert
    inputLang="yaml"
    outputLang="json"
    convertFn={convertYamlToJson}
  />
    <h2 className="text-xl font-semibold mt-6 mb-2">Why convert YAML to JSON?</h2>
    <ul className="list-disc list-inside text-left mb-3">
      <li>Integrate YAML-based configs with JavaScript/TypeScript projects.</li>
      <li>Prepare YAML for use in REST APIs, NoSQL databases, or cloud deployments.</li>
      <li>Facilitate migration from YAML-based to JSON-based systems.</li>
    </ul>
    <h2 className="text-xl font-semibold mt-6 mb-2">How to use this tool:</h2>
    <ol className="list-decimal list-inside text-left mb-3">
      <li>Paste or type your YAML data into the left editor.</li>
      <li>Click the <b>Convert</b> button.</li>
      <li>Copy the generated JSON from the right editor.</li>
    </ol>
    <h2 className="text-xl font-semibold mt-6 mb-2">Example</h2>
    <div className="bg-gray-100 dark:bg-gray-800 rounded p-3 text-left text-sm mb-3 overflow-x-auto">
      <b>Input YAML:</b>
      <pre className="whitespace-pre-wrap">{`name: John\nage: 30\nheight: 5.9`}</pre>
      <b>Output JSON:</b>
      <pre className="whitespace-pre-wrap">{`{
  "name": "John",
  "age": 30,
  "height": 5.9
}`}</pre>
    </div>
    <p className="mt-4">Need help? See our <a href="/about" className="text-blue-600 underline">About</a> page or contact us for support.</p>
  </section>
  
  {/* AdSense Ad - Placed below converter */}
  <AdSenseAd adSlot="9698302360" />
</div>
  );
};

export default YamlToJson;
